<i
  class="f-i f-i-info text-muted align-middle cursor-pointer"
  container="body"
  fMobilePopover
  [mobilePopoverTitle]="localizedTitle()"
  [ngbPopover]="infoPopoverContent"
  [ngClass]="iconSize()"
  [triggers]="'hover focus'"
  [attr.data-automation-id]="'icon-' + title()"
></i>

@if (isShowTitle()) {
<span>{{ localizedTitle() }}</span>
}

<ng-template #infoPopoverContent>
  <div>{{ mainInfo() }}</div>

  @if (infoBottomPrimary() || (hasInfoBottomSecondary())) {
  <div class="border-top mt-2">
    @if(infoBottomPrimary()) {
    <div class="mt-2">{{ infoBottomPrimary() }}</div>
    } @if (hasInfoBottomSecondary()) {
    <div class="mt-1">{{ infoBottomSecondary() }}</div>

    }
  </div>
  }
</ng-template>
